<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_v">For Geraldine Neidenbach<br/>and Martin Chiaverini<br/>with all my love</a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?5d5bd1fa